import { render, staticRenderFns } from "./UploadMethodReport.vue?vue&type=template&id=ec24c710"
import script from "./UploadMethodReport.vue?vue&type=script&lang=js"
export * from "./UploadMethodReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports